import { gql } from '@apollo/client';

export const FETCH_CONSENT = gql`
  query noAuthgetAllPublicConsents($functionalityType: FunctionalityType, $consentType: MemberConsentType) {
    noAuthgetAllPublicConsents(
      functionalityType: $functionalityType
      consentType: $consentType
    ) {
      version
      htmlContent
      consentType
      functionalityType
    }
  }
`;
export const FETCH_TC_FOR_SCHEDULE_APPOINTMENT = gql`
  query getAllPublicConsents(
    $functionalityType: FunctionalityType
    $consentType: MemberConsentType
  ) {
    getAllPublicConsents(
      functionalityType: $functionalityType
      consentType: $consentType
    ) {
      version
      htmlContent
    }
  }
`;
